import {
	Component,
	OnInit,
	Output,
	ViewChild,
	EventEmitter
} from '@angular/core'
import { AWSService } from '../../../services/aws.service'
import { ViewValidation } from 'src/app/_helpers/ViewValidation'
import { NgForm } from '@angular/forms'
import { getTreeFormatCode, getTreeLocationCategoryCode, getUniqueId } from 'src/app/_helpers/Utils'
import { DataCsvInventory } from 'src/app/models/DataCsvInventory'
import { IHandlerOperation } from 'src/app/models/HandlerOperation'
import { InventoryService } from 'src/app/services/inventory.service'
import { ISpecies } from 'src/app/models/Species'
import { SpeciesService } from 'src/app/services/species.service'
import { EvaluationINV1, ImportInventoryError, InventoryImport } from 'src/app/models/Inventory'
import { NotificationService } from 'src/app/services/notification.service'

@Component({
	selector: 'app-data-csv-inventory',
	templateUrl: './data-csv-inventory.component.html'
})

export class DataCsvInventoryComponent implements OnInit {

	@Output() public getInventorys: any = new EventEmitter()
	@Output() public clearImage: any = new EventEmitter()
	@Output() public getImports: any = new EventEmitter()

	constructor(
		public notificationService: NotificationService,
		private awsService: AWSService,
		private inventoryService: InventoryService,
		private speciesService: SpeciesService
	) { }

	public ViewValidation: ViewValidation = new ViewValidation()

	@ViewChild('form') public form: NgForm
	public companyId = localStorage.getItem('companyId')
	public handlerOperations: Array<IHandlerOperation> = []
	public species: Array<ISpecies> = []
	public evaluationInventory: EvaluationINV1
	public imagesWantDownload: FileList
	public nameFilesImage: Array<string>  = []
	public messageModal: string = ''

	public openModalListImages: boolean = false
	public openFeedbackImages: boolean = false
	public openFeedbackCvs: boolean = false
	public openMocalCancel: boolean = false
	public importComplet: boolean = false

	public userEmails: Array<string> = []
	public importError: Array<ImportInventoryError> = []
	public inventorysForImport: Array<Array<DataCsvInventory>> = []
	public observationImport: string = ''

	public async ngOnInit(): Promise<void> {
		await this.getEvaluationInventory()
		await this.getHandlerOperations()
		await this.getSpecies()
		await this.getUserEmails()
	}

	public async getEvaluationInventory(): Promise<void> {
		this.evaluationInventory =
			await this.inventoryService.findFirstInv1ForCompany(this.companyId).toPromise()
	}

	public async getSpecies(): Promise<void> {
		try {
			this.species =
				await this.speciesService.getSpeciesSimple().toPromise()
		} catch (err) {
			console.log(err)
		}
	}

	public async getHandlerOperations(): Promise<void> {
		try {
			this.handlerOperations =
				await this.inventoryService.getHandlerOperations(this.companyId).toPromise()
		} catch (err) {
			console.log(err)
		}
	}

	public async getUserEmails(): Promise<void> {
		this.userEmails =
			await this.inventoryService.getUserEmails(this.companyId).toPromise()
	}

	public listImagesForUser($event: any): void {
		// Array com links das imagens dos inventários guardadas dentro do localStorage
		const imagesLinksStoraged: Array<string> =
			JSON.parse(localStorage.getItem('imagesInventoryUploaded')) || []

		// Itera sobre os links para pegar apenas os nomes dos Arquivos
		const nameImagesInLocalStorage: Array<string> = imagesLinksStoraged.map(link => {
			const parts = link.split(/[\/.|-]+/)

			return decodeURIComponent(parts[parts.length - 2])
		})

		// Imagens selecionadas pelo usuário
		const imagesSelected: FileList = $event.srcElement.files

		// Converter o FileList em um array
		const imagesSelectedArray = Array.from(imagesSelected)

		// Filtrar os arquivos selecionados que não estão presentes no localStorage
		const imagesNotInLocalStorage = imagesSelectedArray.filter(file => {
			return !nameImagesInLocalStorage.includes(file.name.replace(/\.(png|jpg|jpeg)$/, ''))
		})

		if (imagesNotInLocalStorage.length === 0) {
			this.messageModal = 'As imagens selecionadas já foram importadas.'
			this.openFeedbackImages = true

			return
		}

		// Adicionar os arquivos filtrados à lista de imagens a serem baixadas
		this.imagesWantDownload = this.createFileList(imagesNotInLocalStorage)

		// Adicionar os nomes dos arquivos à lista de nomes de arquivos
		this.nameFilesImage = imagesNotInLocalStorage.map(file => file.name)

		this.openModalListImages = true
		this.messageModal = 'Você deseja inserir realmente essas imagens listadas abaixo?'
	}

	public createFileList(files: Array<File>): FileList {
		const dataTransfer = new DataTransfer()
		for (const file of files) {
			dataTransfer.items.add(file)
		}
		return dataTransfer.files
	}

	public closeModalListImages(): void {
		if (this.notificationService.isLoading) return

		this.imagesWantDownload = null
		this.openModalListImages = false
		this.nameFilesImage = []
	}

	public async uploadImages(): Promise<any> {

		// Array com links das imagens dos inventários guardadas dentro do localStorage
		const imagesLinksStoraged: Array<string> =
			JSON.parse(localStorage.getItem('imagesInventoryUploaded')) || []

		const imagesUploaded = []

		this.notificationService.initLoading()
		for (let index = 0; index < this.imagesWantDownload.length; index++) {

			const fileWithNewName =  new File(
				[this.imagesWantDownload[index]],
				getUniqueId() + '-' + this.imagesWantDownload[index].name,
				{
					type: this.imagesWantDownload[index].type,
					lastModified: this.imagesWantDownload[index].lastModified
				}
			)

			try {
				const data = await this.awsService.uploadToS3(fileWithNewName)
				imagesUploaded.push(data.Location)
			} catch (error) {
				console.log(`Erro ao sincronizar a imagem ${this.imagesWantDownload[index].name}. Erro: ${error}`)
			}

			this.messageModal = `Carregando... ${index}/${this.imagesWantDownload.length}`
		}
		this.notificationService.stopLoading()
		localStorage.setItem('imagesInventoryUploaded', JSON.stringify([...imagesLinksStoraged , ...imagesUploaded]))
		this.closeModalListImages()
		this.messageModal = 'Imagens inseridas com sucesso!'
		this.openFeedbackImages = true
	}

	public closeFeedbackImages(): void {
		this.openFeedbackImages = false
		this.clearImage.emit()
	}

	public async readFileXlms(inventorys: Array<InventoryImport>) {
		// Array com Inventários no formato esperado pela API
		const inventorysMapped: Array<DataCsvInventory> = []

		// Array de imagens dos inventários guardadas dentro do localStorage
		const imagesStoraged: Array<string> =
			JSON.parse(localStorage.getItem('imagesInventoryUploaded')) || []

		// Array para armazenar informações sobre os erros
		const errors: Array<ImportInventoryError> = []

		// Itera sobre os inventários, formatando as entidades e inserindo dentro do Array de Inventários a serem enviados para a API
		inventorys.forEach((inventory, index) => {

			const inventoryMapping: DataCsvInventory = new DataCsvInventory()
			let isInventoryWithError = false

			const errorInfo: ImportInventoryError = {
				row: index + 1,
				error: []
			} // Objeto para armazenar informações sobre o erro, se houver.

			// Representa os nomes das imagens
			const inventoryImageParts: Array<string> = inventory.foto_da_árvore.split(',')

			// Valida se todas as imagens são links do S3 válidos
			const imagesIsValidLinks: boolean = inventoryImageParts.every(image => {
				return this.isValidS3Link(image)
			})

			// Array com imagens para sincronização do inventário
			const imagesToSync: Array<string> = []

			if (imagesIsValidLinks) {
				// Armazena todas os links válidos no array de imagens para sinconização
				inventoryImageParts.forEach(image => {
					imagesToSync.push(image)
				})
			} else {
				// Itera sobre as fotos do localStorage para selecionar as fotos do inventário
				imagesStoraged.forEach(image => {
					const parts = image.split(/[\/.|-]+/)
					if (inventory.foto_da_árvore.includes(decodeURIComponent(parts[parts.length - 2]))) {
						imagesToSync.push(image)
					}
				})
			}

			// Acrescenta um erro se o nome da imagem estiver incorreto.
			if (imagesToSync.length === 0) {
				errorInfo.error.push('Nenhuma imagem encontrada')
				isInventoryWithError = true
			}

			// Encontra a especie dentro da lista de espécies
			const species: ISpecies = this.species.find(specie => {
				return specie.nomenclature.popularName.toLowerCase() === inventory.espécie.toLowerCase() ||
					   specie.nomenclature.scientificName.toLowerCase() === inventory.espécie.toLowerCase()
			})

			// Acrescenta um erro se o nome da espécie estiver incorreto.
			if (!species) {
				errorInfo.error.push('Espécie não encontrada')
				isInventoryWithError = true
			}

			// Array com as recomendações de manejo
			const manysHandlerOperations: Array<string> =
					inventory.recomendações_de_manejo.split(',')

			// Array com recomendações de manejos informadas pelo usuário
			const handlerOperations: Array<{
				handlerOperation: string
			}> = []

			// Encontra as recomendações de manejo dentro da Lista de manejos
			manysHandlerOperations.forEach(operation => {
				const findHandlerOperation = this.handlerOperations.find(handlerOperation => {
					return handlerOperation.operation.toLowerCase() === operation.toLowerCase()
				})

				if (findHandlerOperation) {
					handlerOperations.push({
						handlerOperation: findHandlerOperation._id
					})
				} else {
					// Acrescenta um erro se a recomendação de manejos for inválida
					errorInfo.error.push(`O manejo ${operation} é inválido`)
					isInventoryWithError = true
				}
			})

			// Verifica se o formato da copa informado é válido
			const isCategoryValid = getTreeLocationCategoryCode(inventory.categoria_do_local) != 0

			if (!isCategoryValid) {
				errorInfo.error.push('Cadegoria do local inválida')
				isInventoryWithError = true
			}

			// Verifica se o formato da copa informado é válido
			const isFormatValid = getTreeFormatCode(inventory.formato_da_copa) != 0

			if (!isFormatValid) {
				errorInfo.error.push('Formato da árvore inválido')
				isInventoryWithError = true
			}

			// Verifica se o valor especial é válido
			const isSpecialValueValid =
				inventory.valor_especial.toLowerCase() == 'sim' ||
				inventory.valor_especial.toLowerCase() == 'não'

			if (!isSpecialValueValid) {
				errorInfo.error.push('Valor especial inválido')
				isInventoryWithError = true
			}

			// Verifica se o tipo DAP | CAP é válido
			const isDapCapTypeValid = inventory.dap_cap_tipo == 'DAP' || inventory.dap_cap_tipo == 'CAP'

			if (!isDapCapTypeValid) {
				errorInfo.error.push('Tipo DAP ou CAP inválido')
				isInventoryWithError = true
			}

			// Resposta a primeira pergunta do Inventário
			const manyAnswers: Array<string> =
				inventory.estado_geral.split(',')

			const answersSelected: Array<{
				idMongo: string;
				text: string;
			}> = []

			manyAnswers.forEach(answers => {
				const findAnswer = this.evaluationInventory.answers.find(answer => {
					return answer.text.toLowerCase() === answers.toLowerCase()
				})

				if (findAnswer) {
					answersSelected.push(findAnswer)
				} else {
					errorInfo.error.push(`A alternativa ${answers} é inválida para a pergunta "${this.evaluationInventory.question}"`)
					isInventoryWithError = true
				}
			})

			const inventorAnswers = JSON.parse(JSON.stringify(this.evaluationInventory))
			inventorAnswers.answers = answersSelected

			// Valida se o Email informado é de um usuário ativo
			const emailIsValid: boolean = this.userEmails.includes(inventory.email)

			if (!emailIsValid) {
				errorInfo.error.push('Inventáriante responsavel não cadastrado')
				isInventoryWithError = true
			}

			// Início da montagem do objeto que será enviado para o cadastramento.
			inventoryMapping.requester = inventory.responsável
			inventoryMapping.identificationOffline = getUniqueId()
			inventoryMapping.email_requester = inventory.email
			inventoryMapping.identifier = inventory.identificador
			inventoryMapping.address =  inventory.endereço
			inventoryMapping.locationReference = inventory.referência
			inventoryMapping.lat = Number(inventory.latitude)
			inventoryMapping.lng = Number(inventory.longitude)
			inventoryMapping.media_url_inventory = imagesToSync
			inventoryMapping.species = species ? species._id : ''
			inventoryMapping.characterization = {
				height: inventory.altura,
				specialValue: inventory.valor_especial.toLowerCase() === 'sim' ? true : false,
				characterization_code: getTreeFormatCode(inventory.formato_da_copa),
				fuste: {
					type: inventory.formato_da_copa,
					value: inventory.altura_do_caule
				},
				cup_projection: inventory.projeção_da_copa,
				dap_cap: {
					type: inventory.dap_cap_tipo,
					average: inventory.dap_cap_valor
				}
			}
			inventoryMapping.handlerOperations = handlerOperations
			inventoryMapping.inventorAnswers = inventorAnswers
			inventoryMapping.company = this.companyId
			inventoryMapping.category_tree = getTreeLocationCategoryCode(inventory.categoria_do_local)
			inventoryMapping.create_date = inventory.data
			inventoryMapping.observation = inventory.observações
			inventoryMapping.line = index + 1

			if (isInventoryWithError) {
				errors.push(errorInfo)
			} else {
				inventorysMapped.push(inventoryMapping)
			}
		})

		if (errors.length === 0) {
			this.openFeedbackCvs = true
			this.messageModal = 'Leitura do arquivo concluída'

			this.inventorysForImport =
				this.arrayPartition(inventorysMapped)
		} else {
			throw errors
		}
	}

	public async syncInventorys() {

		this.notificationService.initLoading()

		this.messageModal = 'Carregando...'
		const linksToS3Inventorys: Array<string> = []

		for (let index = 0 ; index < this.inventorysForImport.length ; index++) {

			const inventorysJsonString = JSON.stringify(this.inventorysForImport[index])

			const blob = new Blob([inventorysJsonString], { type: 'text/plain' })

			const file = new File(
				[blob],
				`importacao-inventários-${this.companyId}-part${index + 1}-${new Date().getTime()}.txt`,
				{ type: 'text/plain' }
			)

			const bucketName = 'data-storage-temporary'
			const data = await this.awsService.uploadToS3(file, bucketName)

			linksToS3Inventorys.push(data.Location)
		}

		try {
			const response =
				await this.inventoryService.syncInventoryTree(linksToS3Inventorys, this.observationImport, this.companyId).toPromise()

			this.messageModal = response
			this.getImports.emit()
		} catch (error) {
			this.messageModal = 'Ocorreu um erro ao realizar a importação'
		}

		this.importComplet = true
		this.clearImagesLocalStore()
		this.notificationService.stopLoading()
	}

	public openCloseModalCancelImport(open: boolean) {
		this.openMocalCancel = open
	}

	public cancelImport() {
		this.inventorysForImport = []
		this.nameFilesImage = []

		this.openMocalCancel = false

		this.closeFeedbackCvs()
		this.clearImagesLocalStore()
	}

	public isValidS3Link(link: string): boolean {
		const s3LinkRegex = /^https:\/\/[a-zA-Z0-9.-]+\.s3(-[a-z]+-[0-9])?\.amazonaws\.com\/(.+\/)*([^\/]+)$/

		return s3LinkRegex.test(link)
	}

	public closeFeedbackCvs() {
		this.openFeedbackCvs = false
		this.importComplet = false
		this.observationImport = ''
	}

	public arrayPartition(array: Array<DataCsvInventory>): Array<Array<DataCsvInventory>> {
		const parts: Array<Array<DataCsvInventory>> = []

		for (let i = 0; i < array.length; i += 1000) {
			const part = array.slice(i, i + 1000)
			parts.push(part)
		}

		return parts
	}

	public clearImagesLocalStore() {
		localStorage.removeItem('imagesInventoryUploaded')
	}
}
